<ng-container *ngFor="let service of eligibleServices; let serviceIndex = index">
  <div class="row m-t-md mb-3" *ngIf="service.familyName === planFamilyName">
    <div class="n-padding-r">
      <label [class]="serviceIndex === 0 ? 'form-label m-t-xs' : 'form-label'">
        <tmo-checkbox
          [(ngModel)]="service.selected"
          [name]="'service.offerName' + serviceIndex"
          (onClick)="handleClickEvent(service.id)"
          [disabled]="!service.enabled"
          [checkboxTitle]="softGoodsAEMContent?.serviceOption"
          [id]="'Service-' + service?.id"
        >
          <p
            class="heading-small ps-1 f-15"
            [ngClass]="{ 'header-text-disable': !service.enabled }"
          >
            {{ service?.offerName }}
          </p>
        </tmo-checkbox>
      </label>
    </div>
    <div class="col-12 col-md-12 radio-check-spacer ps-5 mt-1">
      <p
        [ngClass]="{ 'header-text-disable': !service.enabled }"
        class="lead price heading-small f-15"
      >
        {{ service?.price?.monthlyPrice?.salePrice?.amount | currency: 'USD' : 'symbol' }} /{{
          softGoodsAEMContent?.month
        }}. + {{ softGoodsAEMContent?.tax }}
      </p>
    </div>
    <div class="col-12 col-md-12 radio-check-spacer ps-5 mt-2">
      <div *ngIf="service?.description">
        <div class="col-12 m-t-sm p-0 mb-2">
          <p
            for="title"
            class="f-11 lh-1d5"
            [ngClass]="{ 'header-text-disable': textDisable, legal: isLegalText }"
            [innerHTML]="service?.description"
          ></p>
        </div>
      </div>
    </div>
    <div
      class="col-12 m-l-md"
      *ngIf="service?.conflictsAndWarnings && service?.conflictsAndWarnings?.length > 0"
    >
      <div class="col-12">
        <p
          class="ps-0 error-text pt-2 f-11 lh-1d5"
          *ngIf="hardConflictNotifications && hardConflictNotifications[serviceIndex]"
        >
          <i id="errorMessage0" class="f-11 lh-1d5 fa fa-exclamation-circle def"></i>
          {{ hardConflictNotifications[serviceIndex] }}
        </p>
      </div>
      <div class="col-12">
        <p
          class="ps-0 error-text pt-2 f-11 lh-1d5"
          *ngIf="softConflictNotification && softConflictNotification[serviceIndex]"
        >
          <i id="errorMessage0" class="f-11 lh-1d5 fa fa-exclamation-circle def"></i>
          {{ softConflictNotification[serviceIndex] }}
        </p>
      </div>
    </div>
    <div
      class="col-12 m-l-md pt-1"
      *ngIf="cartServiceError && cartServiceError?.offerId === service?.offerCode"
    >
      <div class="col-12">
        <p class="ps-0 error-text pt-2 f-11 lh-1d5">
          <i id="hard-conflict-notification" class="fa fa-flag def alert-icon"></i>
          <span> {{ cartServiceError?.warningDescription }}</span>
        </p>
      </div>
    </div>
  </div>
</ng-container>
